import type { FunctionComponent } from 'react';

import { createStyleHelper } from '../../../shared/utils/class-names';

import styles from './info-box.module.scss';

const style = createStyleHelper(styles, 'info-box');

export interface IInfoBoxProps {
    title: string;
    value: string;
}

export const InfoBox: FunctionComponent<IInfoBoxProps> = ({ title, value }) => {
    return (
        <div className={style()}>
            <span className={style('value')}>{value}</span>
            <span className={style('title')}>{title}</span>
        </div>
    );
};
